export { assertWixPalette, COLORS, getColorValue, isRicosPalette } from './wixPaletteUtils.js';
